module.exports = __webpack_public_path__ + "img/world.dff02de3.svg";